import {
  Stack,
  Text,
  useIsomorphicLayoutEffect
} from "@tamagui/core";
import { animate } from "@tamagui/cubic-bezier-animator";
import { usePresence } from "@tamagui/use-presence";
import { useRef, useState } from "react";
function createAnimations(animations) {
  return {
    View: Stack,
    Text,
    animations,
    usePresence,
    supportsCSSVars: !0,
    useAnimatedNumber(initial) {
      const [val, setVal] = useState(initial);
      return {
        getInstance() {
          return val;
        },
        getValue() {
          return val;
        },
        setValue(next) {
          setVal(next);
        },
        stop() {
        }
      };
    },
    useAnimatedNumberReaction({ hostRef, value }, onValue) {
      useIsomorphicLayoutEffect(() => {
        if (!hostRef.current)
          return;
        const onTransitionEvent = (e) => {
          onValue(value.getValue());
        }, node = hostRef.current;
        return node.addEventListener("transitionstart", onTransitionEvent), node.addEventListener("transitioncancel", onTransitionEvent), node.addEventListener("transitionend", onTransitionEvent), () => {
          node.removeEventListener("transitionstart", onTransitionEvent), node.removeEventListener("transitioncancel", onTransitionEvent), node.removeEventListener("transitionend", onTransitionEvent);
        };
      }, [hostRef, onValue]);
    },
    useAnimatedNumberStyle(val, getStyle) {
      return getStyle(val.getValue());
    },
    useAnimations: ({ props, presence, style, componentState, hostRef }) => {
      const isEntering = !!componentState.unmounted, isExiting = presence?.[0] === !1, sendExitComplete = presence?.[1], initialPositionRef = useRef(null), animationKey = Array.isArray(props.animation) ? props.animation[0] : props.animation, animation = animations[animationKey], keys = props.animateOnly ? props.animateOnly.join(" ") : "all";
      return useIsomorphicLayoutEffect(() => {
        if (!sendExitComplete || !isExiting || !hostRef.current)
          return;
        const node = hostRef.current, onFinishAnimation = () => {
          sendExitComplete?.();
        };
        return node.addEventListener("transitionend", onFinishAnimation), node.addEventListener("transitioncancel", onFinishAnimation), () => {
          node.removeEventListener("transitionend", onFinishAnimation), node.removeEventListener("transitioncancel", onFinishAnimation);
        };
      }, [sendExitComplete, isExiting]), useIsomorphicLayoutEffect(() => {
        if (!hostRef.current || !props.layout)
          return;
        const boundingBox = hostRef.current?.getBoundingClientRect();
        if (isChanged(initialPositionRef.current, boundingBox)) {
          const transform = invert(
            hostRef.current,
            boundingBox,
            initialPositionRef.current
          );
          animate({
            from: transform,
            to: { x: 0, y: 0, scaleX: 1, scaleY: 1 },
            duration: 1e3,
            onUpdate: ({ x, y, scaleX, scaleY }) => {
              hostRef.current.style.transform = `translate(${x}px, ${y}px) scaleX(${scaleX}) scaleY(${scaleY})`;
            },
            // TODO: extract ease-in from string and convert/map it to a cubicBezier array
            cubicBezier: [0, 1.38, 1, -0.41]
          });
        }
        initialPositionRef.current = boundingBox;
      }), animation ? (style.transition = `${keys} ${animation}${props.layout ? ",width 0s, height 0s, margin 0s, padding 0s, transform" : ""}`, process.env.NODE_ENV === "development" && props.debug && console.log("CSS animation", style, { isEntering, isExiting }), { style }) : null;
    }
  };
}
const isChanged = (initialBox, finalBox) => !initialBox || !finalBox ? !1 : JSON.stringify(initialBox) !== JSON.stringify(finalBox), invert = (el, from, to) => {
  const { x: fromX, y: fromY, width: fromWidth, height: fromHeight } = from, { x, y, width, height } = to, transform = {
    x: x - fromX - (fromWidth - width) / 2,
    y: y - fromY - (fromHeight - height) / 2,
    scaleX: width / fromWidth,
    scaleY: height / fromHeight
  };
  return el.style.transform = `translate(${transform.x}px, ${transform.y}px) scaleX(${transform.scaleX}) scaleY(${transform.scaleY})`, transform;
};
export {
  createAnimations
};
